// components/ArtworkNotes/components/NoteSearch.tsx
import React from 'react';

interface NoteSearchProps {
    value: string;
    onChange: (search: string) => void;
    disabled?: boolean;
}

const NoteSearch: React.FC<NoteSearchProps> = ({ value, onChange, disabled = false }) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
        onChange(e.target.value);
    };

    const handleClear = (): void => {
        onChange('');
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>): void => {
        if (e.key === 'Escape') {
            handleClear();
        }
    };

    return (
        <div className="note-search">
            <div className="search-input-wrapper">
                <input
                    type="text"
                    placeholder="Search notes..."
                    value={value}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                    className="search-input"
                    disabled={disabled}
                />
                {value && !disabled && (
                    <button
                        type="button"
                        onClick={handleClear}
                        className="search-clear"
                        aria-label="Clear search"
                    >
                        ×
                    </button>
                )}
                <span className="search-icon">🔍</span>
            </div>
            {value && (
                <div className="search-hint">
                    Results will update as you type...
                </div>
            )}
        </div>
    );
};

export default NoteSearch;